import * as angular from "angular";
import {IController} from "angular";

export class DashboardsTableComponent implements IController {

  infiniteScroll: any;
  favoriteDashboardId: string;
  currentSelectedDashboardId: string;
  onSelectDashboard: Function;
  onSetDashboardAsFavorite: Function;
}

angular
  .module('bringoz.admin.dashboards')
  .component('dashboardsTable', {
    bindings: {
      infiniteScroll: '<',
      favoriteDashboardId: '<?',
      currentSelectedDashboardId: '<?',
      onSelectDashboard: '&',
      onSetDashboardAsFavorite: '&'
    },
    template: require('./dashboards-table.html').default,
    controller: DashboardsTableComponent
  });
